import { MouseEventHandler } from "react";
import clsx from "clsx";

import "./RoundedButton.css";
import { ButtonVariant } from "../../lib/types";

type Props = {
  text: string;
  variant?: ButtonVariant;
  transparent?: boolean;
  onClick: MouseEventHandler;
};
const RoundedButton = ({
  text,
  variant = ButtonVariant.primary,
  transparent = false,
  onClick,
}: Props) => {
  return (
    <div className="RoundedButtonWrapper">
    <button className={clsx(variant, "button", {transparent})} onClick={onClick}>
      {text}
    </button>
    </div>
  );
};

export default RoundedButton;
